import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Box, Link, Typography } from '@mui/material';
import WhiteTHLogo from '../assets/WhiteTHLogo';
import LoggedInUserAvatar from './LoggedInUserAvatar';
// eslint-disable-next-line import/no-cycle
import Routes from '../../routing/routes';
import useNavigateHome from '../hooks/useNavigateHome';

export default function Header() {
    const { pathname } = useLocation();
    const isAuthenticated = useSelector((state: any) => state.authentication.isAuthenticated);
    const { url: navigateHomeUrl } = useNavigateHome();

    if (Routes.CREATE_ACCOUNT.path === pathname || Routes.CREATE_ACCOUNT_CONVERT.path === pathname) {
        return null;
    }

    const hideTitle = () => {
        let hiddenClass = '';

        const hiddenPaths = [
            Routes.LOGIN.path,
            Routes.CREATE_ACCOUNT.path,
            Routes.CREATE_ACCOUNT_CONVERT.path,
            Routes.FORGOT_PASSWORD.path,
            Routes.ACCEPT_ASSISTANT_COACH.path
        ];
        if (hiddenPaths.indexOf(pathname) > -1) {
            hiddenClass = 'hide';
        }

        return hiddenClass;
    };

    return (
        <Box data-testid="header" className="header">
            <Box className="menu">
                <Link href={navigateHomeUrl}>
                    <WhiteTHLogo className={'whiteTHLogo'} />
                </Link>
                <Typography className={hideTitle()} variant="h1">
                    Settings
                </Typography>
            </Box>
            <Box className="menu">
                {isAuthenticated ? <LoggedInUserAvatar /> : null}
            </Box>
        </Box>
    );
}
